import {makeThemeProps} from "src/themes/utils/utils";

export default (theme, site, props) => {
  const themeStyles = makeThemeProps(theme, site);
  return themeStyles.getProductCardProps(theme, props, site);
};
